export const constants = {
    resultsPageElementId: "answers-container",
    yextVersion: "1.5"
};
